import React from 'react'
import { useTranslation } from 'react-i18next'

import { useWindowResize } from '@utils/domUtils'

import { NameDto } from '@model/NameDto'

import type { ModalProps } from '../types'
import { SortModalDesktop } from './SortModalDesktop'
import { SortModalMobile } from './SortModalMobile'

interface SortModalProps extends ModalProps {
  title?: string
  options: SortOption[]
  onConfirm(option: string, sortBy: SortOrder, sortName: string): void
}

type SortOption = string | NameDto<string>
type SortOrder = 'ASC' | 'DESC'

export const SortModal: React.FC<SortModalProps> = (props) => {
  const { title, onConfirm, onClose, ...restProps } = props

  const isMobile = useWindowResize()
  const { t } = useTranslation()

  const handleConfirm = (option: string, sortBy: SortOrder, sortName: string): void => {
    onConfirm(option, sortBy, sortName)
    onClose()
  }

  const newTitle: string = title ?? String(t('Sort by'))

  return isMobile ? (
    <SortModalMobile {...restProps} title={newTitle} onConfirm={handleConfirm} onClose={onClose} />
  ) : (
    <SortModalDesktop {...restProps} title={newTitle} onConfirm={handleConfirm} onClose={onClose} />
  )
}
